import { FC } from 'react';
import Image from './assets/qr/QrMojeo2MobileAppLink';

const QrCodeMojeO2MobileApp: FC = () => {
  return <img src={Image} alt="QR code" style={{ maxWidth: '100%', maxHeight: '100%' }} />;
};

export default QrCodeMojeO2MobileApp;
